import React, { useState, useEffect } from "react";
import api from "../api";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useNotification } from "../context/NotificationContext";

const LoginPage = ({ onLogin }) => {
  const { showToast } = useNotification();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("expired")) {
      showToast("انتهت صلاحية الجلسة، برجاء تسجيل الدخول مرة أخرى.", "warning");
    }
  }, [location, showToast]);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) return;

    setLoading(true);
    try {
      const res = await api.post("/api/auth/login", { email, password });
      const { accessToken, user } = res.data;
      localStorage.setItem("youmak_token", accessToken);
      localStorage.setItem("youmak_user", JSON.stringify(user));
      onLogin(user);

      if (user.role === "admin") {
        navigate("/admin/users");
      } else {
        navigate("/client");
      }
    } catch (err) {
      showToast(err.response?.data?.message || "بيانات الدخول غلط، حاول تاني.", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light px-3" dir="rtl" style={{ background: 'var(--bg)' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-celebration shadow-lg p-4 p-md-5 w-100"
        style={{ maxWidth: '500px', border: '1px solid var(--primary-dim)' }}
      >
        <div className="text-center mb-5">
          <div className="text-primary fw-black display-4 mb-3" style={{ fontFamily: 'var(--font-headline)' }}>يومك</div>
          <h1 className="h2 fw-black text-dark mb-2">تسجيل الدخول</h1>
          <p className="text-muted">أهلاً بعودتك، كمل بياناتك للدخول للوحة التحكم.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="form-label fw-bold text-muted small mb-2 d-block text-end">البريد الإلكتروني</label>
            <div className="input-group">
              <span className="input-group-text bg-light border-0"><span className="material-symbols-outlined text-muted fs-5">mail</span></span>
              <input
                type="email"
                className="form-control bg-light border-0 py-3"
                dir="ltr"
                placeholder="example@domain.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label fw-bold text-muted small mb-2 d-block text-end">كلمة السر</label>
            <div className="input-group">
              <span className="input-group-text bg-light border-0"><span className="material-symbols-outlined text-muted fs-5">lock</span></span>
              <input
                type="password"
                className="form-control bg-light border-0 py-3"
                dir="ltr"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100 py-3 fw-black fs-5 shadow-sm mt-3"
            disabled={loading}
          >
            {loading ? "جاري الدخول..." : "دخول"}
          </button>
        </form>

        <div className="mt-5 text-center">
          <p className="mb-3">
            معندكش حساب؟
            <Link className="text-primary fw-bold text-decoration-none ms-2" to="/register">اشتراك جديد</Link>
          </p>
          <hr className="my-4 opacity-10" />
          <Link to="/" className="text-muted text-sm text-decoration-none hover-primary transition-soft d-inline-flex align-items-center gap-2">
            <span className="material-symbols-outlined fs-6">arrow_back</span>
            العودة للرئيسية
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginPage;
